import React from "react";

export default function SeparatorLine(props: { className?: string }) {
    return <div className={props?.className} style={{ borderTop: "solid 1px lightgray" }} />
}